import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
const Select = ({ value, items, index, action }) => {
  const dispatch = useDispatch();
  const [option, setOption] = useState(value);

  const [openOptions, setOpenoption] = useState(false);

  const [togglecatgeories, setTogglecategories] = useState({
    Index: -1,
    State: false,
  });

  return (
    <div className="bg-white border relative group  border-[#33393f] rounded-md min-w-[160px] max-w-[180px] flex gap-1 p-3  justify-center items-center">
      <div
        className="flex justify-center items-center"
        onClick={(e) => {
          e.stopPropagation();
          setOpenoption(!openOptions);
          setTogglecategories({
            Index: index,
            State: !togglecatgeories?.State,
          });
        }}
      >
        <input
          type="text"
          className="w-full bg-white  focus:outline-none text-[14px] "
          value={option}
          disabled
        />
        <button
          type="button"
          className=""
          onClick={(e) => {
            e.stopPropagation();
            setTogglecategories({
              Index: index,
              State: !togglecatgeories?.State,
            });
          }}
        >
          <img
            src="./assets/icons/dpd_arrow.png"
            alt=""
            className={`${
              togglecatgeories?.Index == index && togglecatgeories?.State
                ? "rotate-0"
                : "rotate-180"
            } transition-all duration-300 ease-in-out mx-2 `}
            width={12}
            height={8}
          />
        </button>
      </div>
      {togglecatgeories?.State && togglecatgeories?.Index == index && (
        <div className="absolute   top-[50px] border flex flex-col rounded-lg  px-2 py-4 shadow-md bg-white  text-[14px] text-[#333333] z-20  max-h-[200px] overflow-y-scroll overflow-x-hidden max-w-[180px]">
          {items?.map((item, index) => {
            return (
              <p
                key={index}
                className="p-2 rounded-lg min-w-[170px] hover:bg-[#f5f5f5] cursor-pointer"
                onClick={() => {
                  setOption(item);
                  dispatch(action(item));
                  setTogglecategories({ Index: index, State: false });
                }}
              >
                {item}
              </p>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Select;

{
  /* <FontAwesomeIcon
          icon={faCaretDown}
          style={{ color: "#333940" }}
          className="cursor-pointer"
        /> */
}
